import Box from '@mui/material/Box';

import { useBoolean } from '@zeta-core';
import NavVertical from './nav-vertical';
import { NAV } from '../config-layout';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function RegisterAdvisorLayout({ children }: Props) {
  const nav = useBoolean();

  const renderNavVertical = <NavVertical openNav={nav.value} />;

  return (
    <Box
      sx={{
        minHeight: 1,
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      {renderNavVertical}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: 1,
          display: 'flex',
          flexDirection: 'column',
          width: `calc(100vw - ${NAV.W_VERTICAL_ONBOARDING})`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
